import { createReducer, on } from '@ngrx/store';
import * as WorkLogsActions from './work-logs.actions';
import { initialWorkLogsState } from './work-logs.state';

export const workLogsReducer = createReducer(
  initialWorkLogsState,

  on(WorkLogsActions.loadWorkLogs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.loadWorkLogsSuccess, (state, { workLogs, pagination }) => ({
    ...state,
    workLogs,
    loading: false,
    error: null,
    pagination,
  })),

  on(WorkLogsActions.loadWorkLogsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkLogsActions.adminCreateWorkLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.adminCreateWorkLogSuccess, (state, { workLog }) => ({
    ...state,
    workLogs: [ workLog, ...state.workLogs ],
    loading: false,
    error: null,
  })),

  on(WorkLogsActions.adminCreateWorkLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkLogsActions.approveWorkLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.approveWorkLogSuccess, (state, { workLog }) => ({
    ...state,
    workLogs: state.workLogs.map(wl => wl.id === workLog.id ? workLog : wl),
    loading: false,
    error: null,
  })),

  on(WorkLogsActions.approveWorkLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkLogsActions.rejectWorkLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.rejectWorkLogSuccess, (state, { workLog }) => ({
    ...state,
    workLogs: state.workLogs.map(wl => wl.id === workLog.id ? workLog : wl),
    loading: false,
    error: null,
  })),

  on(WorkLogsActions.rejectWorkLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkLogsActions.updateWorkLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.updateWorkLogSuccess, (state, { workLog }) => ({
    ...state,
    workLogs: state.workLogs.map(wl => wl.id === workLog.id ? workLog : wl),
    loading: false,
    error: null,
  })),

  on(WorkLogsActions.updateWorkLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(WorkLogsActions.deleteWorkLog, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(WorkLogsActions.deleteWorkLogSuccess, (state, { id }) => ({
    ...state,
    workLogs: state.workLogs.filter(wl => wl.id !== id),
    loading: false,
    error: null,
  })),

  on(WorkLogsActions.deleteWorkLogFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

